import { Flex, IconPlus, Text, useMenuState } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { FieldGroupBox, MenuButtonWithIcon } from 'ui'
import { BuyAndWinBenefitVariant } from '../../../../../../typings'
import { BenefitMenu } from '../../../../../BenefitMenu'
import styles from '../../styles'
import { BuyAndWinBenefitOptions } from '../constants'
import { messages } from '../messages'

type EmptyBenefitProps = {
  name: string
  onAdd: (type: BuyAndWinBenefitVariant) => void
}

export function EmptyBenefit(props: EmptyBenefitProps) {
  const { name, onAdd } = props
  const { $t } = useIntl()
  const menuState = useMenuState({ placement: 'bottom-start' })

  return (
    <FieldGroupBox name={name}>
      <Flex direction="column" className={styles.view.content}>
        <Text variant="action1">
          <FormattedMessage {...messages.emptyTitle} />
        </Text>

        <MenuButtonWithIcon
          state={menuState}
          icon={<IconPlus />}
          label={$t(messages.addBenefit)}
          variant="secondary"
        />
        <BenefitMenu
          state={menuState}
          onAdd={onAdd}
          options={BuyAndWinBenefitOptions}
        />
      </Flex>
    </FieldGroupBox>
  )
}
